// REST API contract. Every /api endpoint takes and returns these messages.
// Wire format: binary protobuf (Content-Type / Accept: application/x-protobuf). The server also
// accepts and returns the canonical proto3 JSON mapping when the request uses application/json
// (useful for curl and tests). Route table: docs/ARCHITECTURE.md "REST API".

// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file gunrun/v1/api.proto (package gunrun.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { GameMode, Loadout, ModeRules, RoomKind, TeamScores } from "./common_pb";
import { file_gunrun_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gunrun/v1/api.proto.
 */
export const file_gunrun_v1_api: GenFile = /*@__PURE__*/
  fileDesc("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", [file_gunrun_v1_common]);

/**
 * Body of every 4xx/5xx response.
 *
 * @generated from message gunrun.v1.ErrorResponse
 */
export type ErrorResponse = Message<"gunrun.v1.ErrorResponse"> & {
  /**
   * human readable message
   *
   * @generated from field: string error = 1;
   */
  error: string;

  /**
   * snake_case machine code, e.g. "invalid_loadout", "locked_item", "unauthorized"
   *
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message gunrun.v1.ErrorResponse.
 * Use `create(ErrorResponseSchema)` to create a new message.
 */
export const ErrorResponseSchema: GenMessage<ErrorResponse> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 0);

/**
 * @generated from message gunrun.v1.User
 */
export type User = Message<"gunrun.v1.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * absent for guests
   *
   * @generated from field: optional string username = 3;
   */
  username?: string | undefined;

  /**
   * @generated from field: bool is_guest = 4;
   */
  isGuest: boolean;
};

/**
 * Describes the message gunrun.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 1);

/**
 * @generated from message gunrun.v1.Profile
 */
export type Profile = Message<"gunrun.v1.Profile"> & {
  /**
   * @generated from field: uint32 level = 1;
   */
  level: number;

  /**
   * lifetime XP
   *
   * @generated from field: uint32 xp = 2;
   */
  xp: number;

  /**
   * @generated from field: uint32 xp_into_level = 3;
   */
  xpIntoLevel: number;

  /**
   * 0 at max level
   *
   * @generated from field: uint32 xp_for_next = 4;
   */
  xpForNext: number;

  /**
   * @generated from field: float rating = 5;
   */
  rating: number;

  /**
   * @generated from field: string rank_tier = 6;
   */
  rankTier: string;

  /**
   * @generated from field: uint32 matches = 7;
   */
  matches: number;

  /**
   * @generated from field: uint32 wins = 8;
   */
  wins: number;

  /**
   * @generated from field: uint32 kills = 9;
   */
  kills: number;

  /**
   * @generated from field: uint32 deaths = 10;
   */
  deaths: number;

  /**
   * @generated from field: uint32 assists = 11;
   */
  assists: number;

  /**
   * @generated from field: uint32 headshots = 12;
   */
  headshots: number;

  /**
   * @generated from field: uint32 playtime_sec = 13;
   */
  playtimeSec: number;
};

/**
 * Describes the message gunrun.v1.Profile.
 * Use `create(ProfileSchema)` to create a new message.
 */
export const ProfileSchema: GenMessage<Profile> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 2);

/**
 * @generated from message gunrun.v1.WeaponProgress
 */
export type WeaponProgress = Message<"gunrun.v1.WeaponProgress"> & {
  /**
   * @generated from field: string weapon = 1;
   */
  weapon: string;

  /**
   * @generated from field: uint32 xp = 2;
   */
  xp: number;

  /**
   * @generated from field: uint32 level = 3;
   */
  level: number;

  /**
   * @generated from field: uint32 kills = 4;
   */
  kills: number;

  /**
   * @generated from field: uint32 headshots = 5;
   */
  headshots: number;
};

/**
 * Describes the message gunrun.v1.WeaponProgress.
 * Use `create(WeaponProgressSchema)` to create a new message.
 */
export const WeaponProgressSchema: GenMessage<WeaponProgress> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 3);

/**
 * @generated from message gunrun.v1.IdList
 */
export type IdList = Message<"gunrun.v1.IdList"> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];
};

/**
 * Describes the message gunrun.v1.IdList.
 * Use `create(IdListSchema)` to create a new message.
 */
export const IdListSchema: GenMessage<IdList> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 4);

/**
 * @generated from message gunrun.v1.Unlocks
 */
export type Unlocks = Message<"gunrun.v1.Unlocks"> & {
  /**
   * @generated from field: repeated string weapons = 1;
   */
  weapons: string[];

  /**
   * weapon id -> unlocked attachment ids
   *
   * @generated from field: map<string, gunrun.v1.IdList> attachments = 2;
   */
  attachments: { [key: string]: IdList };

  /**
   * @generated from field: repeated string perks = 3;
   */
  perks: string[];

  /**
   * @generated from field: repeated string equipment = 4;
   */
  equipment: string[];

  /**
   * weapon id -> unlocked camo ids ("none" always included)
   *
   * @generated from field: map<string, gunrun.v1.IdList> camos = 5;
   */
  camos: { [key: string]: IdList };
};

/**
 * Describes the message gunrun.v1.Unlocks.
 * Use `create(UnlocksSchema)` to create a new message.
 */
export const UnlocksSchema: GenMessage<Unlocks> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 5);

/**
 * @generated from message gunrun.v1.Me
 */
export type Me = Message<"gunrun.v1.Me"> & {
  /**
   * @generated from field: gunrun.v1.User user = 1;
   */
  user?: User | undefined;

  /**
   * @generated from field: gunrun.v1.Profile profile = 2;
   */
  profile?: Profile | undefined;

  /**
   * @generated from field: repeated gunrun.v1.WeaponProgress weapon_progress = 3;
   */
  weaponProgress: WeaponProgress[];

  /**
   * @generated from field: gunrun.v1.Unlocks unlocks = 4;
   */
  unlocks?: Unlocks | undefined;

  /**
   * always 5 slots
   *
   * @generated from field: repeated gunrun.v1.Loadout loadouts = 5;
   */
  loadouts: Loadout[];

  /**
   * @generated from field: uint32 selected_loadout = 6;
   */
  selectedLoadout: number;
};

/**
 * Describes the message gunrun.v1.Me.
 * Use `create(MeSchema)` to create a new message.
 */
export const MeSchema: GenMessage<Me> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 6);

/**
 * @generated from message gunrun.v1.GuestRequest
 */
export type GuestRequest = Message<"gunrun.v1.GuestRequest"> & {
  /**
   * @generated from field: optional string display_name = 1;
   */
  displayName?: string | undefined;
};

/**
 * Describes the message gunrun.v1.GuestRequest.
 * Use `create(GuestRequestSchema)` to create a new message.
 */
export const GuestRequestSchema: GenMessage<GuestRequest> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 7);

/**
 * With a guest bearer token the guest account is claimed (progress kept); otherwise a new account is created.
 *
 * @generated from message gunrun.v1.RegisterRequest
 */
export type RegisterRequest = Message<"gunrun.v1.RegisterRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: optional string display_name = 3;
   */
  displayName?: string | undefined;
};

/**
 * Describes the message gunrun.v1.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema: GenMessage<RegisterRequest> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 8);

/**
 * @generated from message gunrun.v1.LoginRequest
 */
export type LoginRequest = Message<"gunrun.v1.LoginRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message gunrun.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 9);

/**
 * @generated from message gunrun.v1.AuthResponse
 */
export type AuthResponse = Message<"gunrun.v1.AuthResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: gunrun.v1.Me me = 2;
   */
  me?: Me | undefined;
};

/**
 * Describes the message gunrun.v1.AuthResponse.
 * Use `create(AuthResponseSchema)` to create a new message.
 */
export const AuthResponseSchema: GenMessage<AuthResponse> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 10);

/**
 * @generated from message gunrun.v1.UpdateMeRequest
 */
export type UpdateMeRequest = Message<"gunrun.v1.UpdateMeRequest"> & {
  /**
   * @generated from field: string display_name = 1;
   */
  displayName: string;
};

/**
 * Describes the message gunrun.v1.UpdateMeRequest.
 * Use `create(UpdateMeRequestSchema)` to create a new message.
 */
export const UpdateMeRequestSchema: GenMessage<UpdateMeRequest> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 11);

/**
 * PUT /api/loadouts/{index}: body is a Loadout.
 *
 * @generated from message gunrun.v1.LoadoutsResponse
 */
export type LoadoutsResponse = Message<"gunrun.v1.LoadoutsResponse"> & {
  /**
   * @generated from field: repeated gunrun.v1.Loadout loadouts = 1;
   */
  loadouts: Loadout[];
};

/**
 * Describes the message gunrun.v1.LoadoutsResponse.
 * Use `create(LoadoutsResponseSchema)` to create a new message.
 */
export const LoadoutsResponseSchema: GenMessage<LoadoutsResponse> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 12);

/**
 * @generated from message gunrun.v1.SelectLoadoutRequest
 */
export type SelectLoadoutRequest = Message<"gunrun.v1.SelectLoadoutRequest"> & {
  /**
   * @generated from field: uint32 index = 1;
   */
  index: number;
};

/**
 * Describes the message gunrun.v1.SelectLoadoutRequest.
 * Use `create(SelectLoadoutRequestSchema)` to create a new message.
 */
export const SelectLoadoutRequestSchema: GenMessage<SelectLoadoutRequest> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 13);

/**
 * 0..100 values for the loadout UI stat bars.
 *
 * @generated from message gunrun.v1.WeaponBars
 */
export type WeaponBars = Message<"gunrun.v1.WeaponBars"> & {
  /**
   * @generated from field: uint32 damage = 1;
   */
  damage: number;

  /**
   * @generated from field: uint32 fire_rate = 2;
   */
  fireRate: number;

  /**
   * @generated from field: uint32 range = 3;
   */
  range: number;

  /**
   * @generated from field: uint32 accuracy = 4;
   */
  accuracy: number;

  /**
   * @generated from field: uint32 mobility = 5;
   */
  mobility: number;

  /**
   * @generated from field: uint32 control = 6;
   */
  control: number;
};

/**
 * Describes the message gunrun.v1.WeaponBars.
 * Use `create(WeaponBarsSchema)` to create a new message.
 */
export const WeaponBarsSchema: GenMessage<WeaponBars> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 14);

/**
 * @generated from message gunrun.v1.WeaponInfo
 */
export type WeaponInfo = Message<"gunrun.v1.WeaponInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * "smg", "rifle", "burst_rifle", "shotgun", "marksman", "sniper", "pistol", "machine_pistol", "revolver", "melee"
   *
   * @generated from field: string class = 3;
   */
  class: string;

  /**
   * @generated from field: gunrun.v1.SlotKind slot = 4;
   */
  slot: SlotKind;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: gunrun.v1.FireMode fire_mode = 6;
   */
  fireMode: FireMode;

  /**
   * @generated from field: float rpm = 7;
   */
  rpm: number;

  /**
   * @generated from field: uint32 pellets = 8;
   */
  pellets: number;

  /**
   * @generated from field: float dmg_near = 9;
   */
  dmgNear: number;

  /**
   * @generated from field: float dmg_far = 10;
   */
  dmgFar: number;

  /**
   * @generated from field: float range_near = 11;
   */
  rangeNear: number;

  /**
   * @generated from field: float range_far = 12;
   */
  rangeFar: number;

  /**
   * @generated from field: float head_mult = 13;
   */
  headMult: number;

  /**
   * @generated from field: float limb_mult = 14;
   */
  limbMult: number;

  /**
   * @generated from field: uint32 mag = 15;
   */
  mag: number;

  /**
   * @generated from field: float reload = 16;
   */
  reload: number;

  /**
   * @generated from field: float ads_time = 17;
   */
  adsTime: number;

  /**
   * @generated from field: float mobility = 18;
   */
  mobility: number;

  /**
   * @generated from field: float ads_mobility = 19;
   */
  adsMobility: number;

  /**
   * @generated from field: float hip_spread = 20;
   */
  hipSpread: number;

  /**
   * @generated from field: float ads_spread = 21;
   */
  adsSpread: number;

  /**
   * unlock order
   *
   * @generated from field: repeated string allowed_attachments = 22;
   */
  allowedAttachments: string[];

  /**
   * weapon level per allowed attachment (parallel array)
   *
   * @generated from field: repeated uint32 attachment_levels = 23;
   */
  attachmentLevels: number[];

  /**
   * player level
   *
   * @generated from field: uint32 unlock_level = 24;
   */
  unlockLevel: number;

  /**
   * @generated from field: gunrun.v1.WeaponBars bars = 25;
   */
  bars?: WeaponBars | undefined;
};

/**
 * Describes the message gunrun.v1.WeaponInfo.
 * Use `create(WeaponInfoSchema)` to create a new message.
 */
export const WeaponInfoSchema: GenMessage<WeaponInfo> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 15);

/**
 * @generated from message gunrun.v1.AttachmentInfo
 */
export type AttachmentInfo = Message<"gunrun.v1.AttachmentInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: gunrun.v1.AttachmentSlot slot = 3;
   */
  slot: AttachmentSlot;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * human readable, e.g. "+25% range"
   *
   * @generated from field: repeated string effects = 5;
   */
  effects: string[];
};

/**
 * Describes the message gunrun.v1.AttachmentInfo.
 * Use `create(AttachmentInfoSchema)` to create a new message.
 */
export const AttachmentInfoSchema: GenMessage<AttachmentInfo> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 16);

/**
 * @generated from message gunrun.v1.PerkInfo
 */
export type PerkInfo = Message<"gunrun.v1.PerkInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: uint32 unlock_level = 4;
   */
  unlockLevel: number;
};

/**
 * Describes the message gunrun.v1.PerkInfo.
 * Use `create(PerkInfoSchema)` to create a new message.
 */
export const PerkInfoSchema: GenMessage<PerkInfo> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 17);

/**
 * @generated from message gunrun.v1.EquipmentInfo
 */
export type EquipmentInfo = Message<"gunrun.v1.EquipmentInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: gunrun.v1.EquipmentKind kind = 3;
   */
  kind: EquipmentKind;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: uint32 unlock_level = 5;
   */
  unlockLevel: number;
};

/**
 * Describes the message gunrun.v1.EquipmentInfo.
 * Use `create(EquipmentInfoSchema)` to create a new message.
 */
export const EquipmentInfoSchema: GenMessage<EquipmentInfo> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 18);

/**
 * @generated from message gunrun.v1.CamoInfo
 */
export type CamoInfo = Message<"gunrun.v1.CamoInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: uint32 weapon_level = 3;
   */
  weaponLevel: number;

  /**
   * two "#rrggbb" colors
   *
   * @generated from field: repeated string colors = 4;
   */
  colors: string[];
};

/**
 * Describes the message gunrun.v1.CamoInfo.
 * Use `create(CamoInfoSchema)` to create a new message.
 */
export const CamoInfoSchema: GenMessage<CamoInfo> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 19);

/**
 * @generated from message gunrun.v1.MapInfo
 */
export type MapInfo = Message<"gunrun.v1.MapInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message gunrun.v1.MapInfo.
 * Use `create(MapInfoSchema)` to create a new message.
 */
export const MapInfoSchema: GenMessage<MapInfo> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 20);

/**
 * @generated from message gunrun.v1.ModeInfo
 */
export type ModeInfo = Message<"gunrun.v1.ModeInfo"> & {
  /**
   * @generated from field: gunrun.v1.GameMode mode = 1;
   */
  mode: GameMode;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: gunrun.v1.ModeRules rules = 3;
   */
  rules?: ModeRules | undefined;
};

/**
 * Describes the message gunrun.v1.ModeInfo.
 * Use `create(ModeInfoSchema)` to create a new message.
 */
export const ModeInfoSchema: GenMessage<ModeInfo> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 21);

/**
 * @generated from message gunrun.v1.UnlockItem
 */
export type UnlockItem = Message<"gunrun.v1.UnlockItem"> & {
  /**
   * @generated from field: gunrun.v1.UnlockKind kind = 1;
   */
  kind: UnlockKind;

  /**
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message gunrun.v1.UnlockItem.
 * Use `create(UnlockItemSchema)` to create a new message.
 */
export const UnlockItemSchema: GenMessage<UnlockItem> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 22);

/**
 * @generated from message gunrun.v1.UnlockGroup
 */
export type UnlockGroup = Message<"gunrun.v1.UnlockGroup"> & {
  /**
   * @generated from field: uint32 level = 1;
   */
  level: number;

  /**
   * @generated from field: repeated gunrun.v1.UnlockItem items = 2;
   */
  items: UnlockItem[];
};

/**
 * Describes the message gunrun.v1.UnlockGroup.
 * Use `create(UnlockGroupSchema)` to create a new message.
 */
export const UnlockGroupSchema: GenMessage<UnlockGroup> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 23);

/**
 * @generated from message gunrun.v1.RankTier
 */
export type RankTier = Message<"gunrun.v1.RankTier"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: float min_rating = 2;
   */
  minRating: number;
};

/**
 * Describes the message gunrun.v1.RankTier.
 * Use `create(RankTierSchema)` to create a new message.
 */
export const RankTierSchema: GenMessage<RankTier> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 24);

/**
 * @generated from message gunrun.v1.ProgressionInfo
 */
export type ProgressionInfo = Message<"gunrun.v1.ProgressionInfo"> & {
  /**
   * @generated from field: uint32 max_level = 1;
   */
  maxLevel: number;

  /**
   * index i = XP from level i+1 to i+2
   *
   * @generated from field: repeated uint32 level_xp = 2;
   */
  levelXp: number[];

  /**
   * @generated from field: repeated gunrun.v1.UnlockGroup unlocks = 3;
   */
  unlocks: UnlockGroup[];

  /**
   * index i = total weapon XP for weapon level i+1
   *
   * @generated from field: repeated uint32 weapon_level_xp = 4;
   */
  weaponLevelXp: number[];

  /**
   * camo id -> weapon level
   *
   * @generated from field: map<string, uint32> camo_levels = 5;
   */
  camoLevels: { [key: string]: number };

  /**
   * @generated from field: repeated gunrun.v1.RankTier rank_tiers = 6;
   */
  rankTiers: RankTier[];
};

/**
 * Describes the message gunrun.v1.ProgressionInfo.
 * Use `create(ProgressionInfoSchema)` to create a new message.
 */
export const ProgressionInfoSchema: GenMessage<ProgressionInfo> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 25);

/**
 * @generated from message gunrun.v1.Catalog
 */
export type Catalog = Message<"gunrun.v1.Catalog"> & {
  /**
   * @generated from field: repeated gunrun.v1.WeaponInfo weapons = 1;
   */
  weapons: WeaponInfo[];

  /**
   * @generated from field: repeated gunrun.v1.AttachmentInfo attachments = 2;
   */
  attachments: AttachmentInfo[];

  /**
   * @generated from field: repeated gunrun.v1.PerkInfo perks = 3;
   */
  perks: PerkInfo[];

  /**
   * @generated from field: repeated gunrun.v1.EquipmentInfo equipment = 4;
   */
  equipment: EquipmentInfo[];

  /**
   * @generated from field: repeated gunrun.v1.CamoInfo camos = 5;
   */
  camos: CamoInfo[];

  /**
   * @generated from field: repeated gunrun.v1.MapInfo maps = 6;
   */
  maps: MapInfo[];

  /**
   * @generated from field: repeated gunrun.v1.ModeInfo modes = 7;
   */
  modes: ModeInfo[];

  /**
   * @generated from field: gunrun.v1.ProgressionInfo progression = 8;
   */
  progression?: ProgressionInfo | undefined;
};

/**
 * Describes the message gunrun.v1.Catalog.
 * Use `create(CatalogSchema)` to create a new message.
 */
export const CatalogSchema: GenMessage<Catalog> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 26);

/**
 * @generated from message gunrun.v1.RoomInfo
 */
export type RoomInfo = Message<"gunrun.v1.RoomInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: gunrun.v1.RoomKind kind = 3;
   */
  kind: RoomKind;

  /**
   * @generated from field: gunrun.v1.GameMode mode = 4;
   */
  mode: GameMode;

  /**
   * @generated from field: string map = 5;
   */
  map: string;

  /**
   * @generated from field: uint32 players = 6;
   */
  players: number;

  /**
   * @generated from field: uint32 max_players = 7;
   */
  maxPlayers: number;

  /**
   * @generated from field: bool has_password = 8;
   */
  hasPassword: boolean;

  /**
   * @generated from field: gunrun.v1.RoomPhase phase = 9;
   */
  phase: RoomPhase;

  /**
   * host display name for custom lobbies
   *
   * @generated from field: optional string host = 10;
   */
  host?: string | undefined;

  /**
   * @generated from field: string region = 11;
   */
  region: string;

  /**
   * @generated from field: optional uint32 time_left_sec = 12;
   */
  timeLeftSec?: number | undefined;

  /**
   * team modes only
   *
   * @generated from field: optional gunrun.v1.TeamScores scores = 13;
   */
  scores?: TeamScores | undefined;

  /**
   * bots in the room (not counted in `players`)
   *
   * @generated from field: uint32 bots = 14;
   */
  bots: number;
};

/**
 * Describes the message gunrun.v1.RoomInfo.
 * Use `create(RoomInfoSchema)` to create a new message.
 */
export const RoomInfoSchema: GenMessage<RoomInfo> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 27);

/**
 * @generated from message gunrun.v1.RoomList
 */
export type RoomList = Message<"gunrun.v1.RoomList"> & {
  /**
   * @generated from field: repeated gunrun.v1.RoomInfo rooms = 1;
   */
  rooms: RoomInfo[];
};

/**
 * Describes the message gunrun.v1.RoomList.
 * Use `create(RoomListSchema)` to create a new message.
 */
export const RoomListSchema: GenMessage<RoomList> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 28);

/**
 * @generated from message gunrun.v1.RoomRuleOverrides
 */
export type RoomRuleOverrides = Message<"gunrun.v1.RoomRuleOverrides"> & {
  /**
   * @generated from field: optional uint32 score_limit = 1;
   */
  scoreLimit?: number | undefined;

  /**
   * @generated from field: optional uint32 time_limit_sec = 2;
   */
  timeLimitSec?: number | undefined;

  /**
   * @generated from field: optional uint32 rounds_to_win = 3;
   */
  roundsToWin?: number | undefined;

  /**
   * @generated from field: optional bool friendly_fire = 4;
   */
  friendlyFire?: boolean | undefined;
};

/**
 * Describes the message gunrun.v1.RoomRuleOverrides.
 * Use `create(RoomRuleOverridesSchema)` to create a new message.
 */
export const RoomRuleOverridesSchema: GenMessage<RoomRuleOverrides> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 29);

/**
 * @generated from message gunrun.v1.CreateRoomRequest
 */
export type CreateRoomRequest = Message<"gunrun.v1.CreateRoomRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: gunrun.v1.GameMode mode = 2;
   */
  mode: GameMode;

  /**
   * @generated from field: string map = 3;
   */
  map: string;

  /**
   * @generated from field: uint32 max_players = 4;
   */
  maxPlayers: number;

  /**
   * @generated from field: optional string password = 5;
   */
  password?: string | undefined;

  /**
   * @generated from field: bool listed = 6;
   */
  listed: boolean;

  /**
   * @generated from field: gunrun.v1.RoomRuleOverrides settings = 7;
   */
  settings?: RoomRuleOverrides | undefined;
};

/**
 * Describes the message gunrun.v1.CreateRoomRequest.
 * Use `create(CreateRoomRequestSchema)` to create a new message.
 */
export const CreateRoomRequestSchema: GenMessage<CreateRoomRequest> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 30);

/**
 * @generated from message gunrun.v1.JoinRoomRequest
 */
export type JoinRoomRequest = Message<"gunrun.v1.JoinRoomRequest"> & {
  /**
   * @generated from field: optional string password = 1;
   */
  password?: string | undefined;
};

/**
 * Describes the message gunrun.v1.JoinRoomRequest.
 * Use `create(JoinRoomRequestSchema)` to create a new message.
 */
export const JoinRoomRequestSchema: GenMessage<JoinRoomRequest> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 31);

/**
 * Returned by room create/join, quick play and a found ranked match: connect to the game with the ticket.
 *
 * @generated from message gunrun.v1.JoinResponse
 */
export type JoinResponse = Message<"gunrun.v1.JoinResponse"> & {
  /**
   * @generated from field: gunrun.v1.RoomInfo room = 1;
   */
  room?: RoomInfo | undefined;

  /**
   * @generated from field: string ticket = 2;
   */
  ticket: string;
};

/**
 * Describes the message gunrun.v1.JoinResponse.
 * Use `create(JoinResponseSchema)` to create a new message.
 */
export const JoinResponseSchema: GenMessage<JoinResponse> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 32);

/**
 * @generated from message gunrun.v1.QuickplayRequest
 */
export type QuickplayRequest = Message<"gunrun.v1.QuickplayRequest"> & {
  /**
   * @generated from field: repeated gunrun.v1.GameMode modes = 1;
   */
  modes: GameMode[];
};

/**
 * Describes the message gunrun.v1.QuickplayRequest.
 * Use `create(QuickplayRequestSchema)` to create a new message.
 */
export const QuickplayRequestSchema: GenMessage<QuickplayRequest> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 33);

/**
 * @generated from message gunrun.v1.RankedQueueRequest
 */
export type RankedQueueRequest = Message<"gunrun.v1.RankedQueueRequest"> & {
  /**
   * @generated from field: gunrun.v1.GameMode mode = 1;
   */
  mode: GameMode;
};

/**
 * Describes the message gunrun.v1.RankedQueueRequest.
 * Use `create(RankedQueueRequestSchema)` to create a new message.
 */
export const RankedQueueRequestSchema: GenMessage<RankedQueueRequest> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 34);

/**
 * Where the caller stands in the ranked queue. POST joins (and answers SEARCHING), GET is polled
 * about once a second while searching (it also keeps the player in the queue), DELETE leaves.
 * FOUND carries the ticket of the formed match; GET answers FOUND again, with a fresh ticket, for
 * as long as the player's match is on and they have not left it (the way back after a dropped
 * connection).
 *
 * @generated from message gunrun.v1.RankedStatus
 */
export type RankedStatus = Message<"gunrun.v1.RankedStatus"> & {
  /**
   * @generated from field: gunrun.v1.RankedState state = 1;
   */
  state: RankedState;

  /**
   * @generated from field: gunrun.v1.GameMode mode = 2;
   */
  mode: GameMode;

  /**
   * @generated from field: uint32 searching_sec = 3;
   */
  searchingSec: number;

  /**
   * waiting for the same mode
   *
   * @generated from field: uint32 players_in_queue = 4;
   */
  playersInQueue: number;

  /**
   * present when state == FOUND
   *
   * @generated from field: optional gunrun.v1.JoinResponse match = 5;
   */
  match?: JoinResponse | undefined;

  /**
   * players per team of a ranked match on this server (all states)
   *
   * @generated from field: uint32 team_size = 6;
   */
  teamSize: number;

  /**
   * SEARCHING: current half-width of the rating window (starts at 100, +50 per 10 s)
   *
   * @generated from field: uint32 rating_window = 7;
   */
  ratingWindow: number;
};

/**
 * Describes the message gunrun.v1.RankedStatus.
 * Use `create(RankedStatusSchema)` to create a new message.
 */
export const RankedStatusSchema: GenMessage<RankedStatus> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 35);

/**
 * @generated from message gunrun.v1.CertHash
 */
export type CertHash = Message<"gunrun.v1.CertHash"> & {
  /**
   * "sha-256"
   *
   * @generated from field: string algorithm = 1;
   */
  algorithm: string;

  /**
   * raw digest, pass to WebTransport serverCertificateHashes
   *
   * @generated from field: bytes value = 2;
   */
  value: Uint8Array;
};

/**
 * Describes the message gunrun.v1.CertHash.
 * Use `create(CertHashSchema)` to create a new message.
 */
export const CertHashSchema: GenMessage<CertHash> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 36);

/**
 * @generated from message gunrun.v1.WebTransportInfo
 */
export type WebTransportInfo = Message<"gunrun.v1.WebTransportInfo"> & {
  /**
   * "https://host:4433/play"
   *
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: repeated gunrun.v1.CertHash cert_hashes = 2;
   */
  certHashes: CertHash[];
};

/**
 * Describes the message gunrun.v1.WebTransportInfo.
 * Use `create(WebTransportInfoSchema)` to create a new message.
 */
export const WebTransportInfoSchema: GenMessage<WebTransportInfo> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 37);

/**
 * @generated from message gunrun.v1.NetInfo
 */
export type NetInfo = Message<"gunrun.v1.NetInfo"> & {
  /**
   * @generated from field: uint32 protocol_version = 1;
   */
  protocolVersion: number;

  /**
   * @generated from field: uint32 tick_rate = 2;
   */
  tickRate: number;

  /**
   * "/play/ws"
   *
   * @generated from field: string websocket_path = 3;
   */
  websocketPath: string;

  /**
   * @generated from field: optional gunrun.v1.WebTransportInfo webtransport = 4;
   */
  webtransport?: WebTransportInfo | undefined;
};

/**
 * Describes the message gunrun.v1.NetInfo.
 * Use `create(NetInfoSchema)` to create a new message.
 */
export const NetInfoSchema: GenMessage<NetInfo> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_api, 38);

/**
 * @generated from enum gunrun.v1.SlotKind
 */
export enum SlotKind {
  /**
   * @generated from enum value: SLOT_KIND_PRIMARY = 0;
   */
  PRIMARY = 0,

  /**
   * @generated from enum value: SLOT_KIND_SECONDARY = 1;
   */
  SECONDARY = 1,

  /**
   * @generated from enum value: SLOT_KIND_MELEE = 2;
   */
  MELEE = 2,
}

/**
 * Describes the enum gunrun.v1.SlotKind.
 */
export const SlotKindSchema: GenEnum<SlotKind> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_api, 0);

/**
 * @generated from enum gunrun.v1.FireMode
 */
export enum FireMode {
  /**
   * @generated from enum value: FIRE_MODE_AUTO = 0;
   */
  AUTO = 0,

  /**
   * @generated from enum value: FIRE_MODE_SEMI = 1;
   */
  SEMI = 1,

  /**
   * @generated from enum value: FIRE_MODE_BURST = 2;
   */
  BURST = 2,

  /**
   * @generated from enum value: FIRE_MODE_PUMP = 3;
   */
  PUMP = 3,

  /**
   * @generated from enum value: FIRE_MODE_BOLT = 4;
   */
  BOLT = 4,

  /**
   * @generated from enum value: FIRE_MODE_MELEE = 5;
   */
  MELEE = 5,
}

/**
 * Describes the enum gunrun.v1.FireMode.
 */
export const FireModeSchema: GenEnum<FireMode> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_api, 1);

/**
 * @generated from enum gunrun.v1.AttachmentSlot
 */
export enum AttachmentSlot {
  /**
   * @generated from enum value: ATTACHMENT_SLOT_OPTIC = 0;
   */
  OPTIC = 0,

  /**
   * @generated from enum value: ATTACHMENT_SLOT_MUZZLE = 1;
   */
  MUZZLE = 1,

  /**
   * @generated from enum value: ATTACHMENT_SLOT_BARREL = 2;
   */
  BARREL = 2,

  /**
   * @generated from enum value: ATTACHMENT_SLOT_MAGAZINE = 3;
   */
  MAGAZINE = 3,

  /**
   * @generated from enum value: ATTACHMENT_SLOT_GRIP = 4;
   */
  GRIP = 4,
}

/**
 * Describes the enum gunrun.v1.AttachmentSlot.
 */
export const AttachmentSlotSchema: GenEnum<AttachmentSlot> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_api, 2);

/**
 * @generated from enum gunrun.v1.EquipmentKind
 */
export enum EquipmentKind {
  /**
   * @generated from enum value: EQUIPMENT_KIND_LETHAL = 0;
   */
  LETHAL = 0,

  /**
   * @generated from enum value: EQUIPMENT_KIND_TACTICAL = 1;
   */
  TACTICAL = 1,
}

/**
 * Describes the enum gunrun.v1.EquipmentKind.
 */
export const EquipmentKindSchema: GenEnum<EquipmentKind> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_api, 3);

/**
 * @generated from enum gunrun.v1.UnlockKind
 */
export enum UnlockKind {
  /**
   * @generated from enum value: UNLOCK_KIND_WEAPON = 0;
   */
  WEAPON = 0,

  /**
   * @generated from enum value: UNLOCK_KIND_PERK = 1;
   */
  PERK = 1,

  /**
   * @generated from enum value: UNLOCK_KIND_EQUIPMENT = 2;
   */
  EQUIPMENT = 2,
}

/**
 * Describes the enum gunrun.v1.UnlockKind.
 */
export const UnlockKindSchema: GenEnum<UnlockKind> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_api, 4);

/**
 * @generated from enum gunrun.v1.RoomPhase
 */
export enum RoomPhase {
  /**
   * @generated from enum value: ROOM_PHASE_WARMUP = 0;
   */
  WARMUP = 0,

  /**
   * @generated from enum value: ROOM_PHASE_LIVE = 1;
   */
  LIVE = 1,

  /**
   * @generated from enum value: ROOM_PHASE_ENDED = 2;
   */
  ENDED = 2,
}

/**
 * Describes the enum gunrun.v1.RoomPhase.
 */
export const RoomPhaseSchema: GenEnum<RoomPhase> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_api, 5);

/**
 * @generated from enum gunrun.v1.RankedState
 */
export enum RankedState {
  /**
   * @generated from enum value: RANKED_STATE_IDLE = 0;
   */
  IDLE = 0,

  /**
   * @generated from enum value: RANKED_STATE_SEARCHING = 1;
   */
  SEARCHING = 1,

  /**
   * @generated from enum value: RANKED_STATE_FOUND = 2;
   */
  FOUND = 2,
}

/**
 * Describes the enum gunrun.v1.RankedState.
 */
export const RankedStateSchema: GenEnum<RankedState> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_api, 6);

